import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import Loadingcontainer from '../loadingcontainer';
import Drilldownplaceholder from '../drilldownplaceholder';
import { generateExcel } from '../../utils/services';
import { updateAppState, updateComponentState } from '../../actions/actions';
import { Bar } from 'react-chartjs-2';
import {DateElement,LocalSelect} from '../utils/utilcomponents';

const colors =  ["#31CDF5","#02AB10","#FB4720"];

const options = {
	maintainAspectRatio: true,
	layout: {
		padding: {
			bottom: 0,
			top: 0
		}
	},
	plugins: {
		datalabels: { 
			display: false 
		}
	},
	scales: {
		xAxes: [{
			barThickness : 10,
			stacked: true,
			gridLines: {
				display: false
			}
		}],
		yAxes: [{
		ticks: {
			beginAtZero: true,
			precision: 0
		}
	}],
	},
	responsive: false,
	legend: {
		display: true,
		position: 'bottom',
		labels: {
		  fontColor: '#91929b',
		  padding: 20
		}
	}
};

class PMAndCalibrationByHospital extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tabClasses: ["show active", ""],
			fromdate : this.props.location && this.props.location.params && this.props.location.params.fromdate ? new Date(this.props.location.params.fromdate) :this.getDate('fromdate'),
			todate : this.props.location && this.props.location.params && this.props.location.params.todate ? new Date(this.props.location.params.todate) : this.getDate('todate'),
			pmtype : this.props.location && this.props.location.params && this.props.location.params.pmtype ? this.props.location.params.pmtype : null,
			menumber : this.props.location && this.props.location.params && this.props.location.params.menumber ? this.props.location.params.menumber : null,
			wonumber : this.props.location && this.props.location.params && this.props.location.params.wonumber ? this.props.location.params.wonumber : null,
			result : [],
			t_sp_scheduled : 0,
			t_sp_completed : 0,
			t_sp_pending : 0,
			t_w_scheduled : 0,
			t_w_completed : 0,
			t_w_pending : 0,
			t_nsp_scheduled : 0,
			t_nsp_completed : 0,
			t_nsp_pending : 0,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.excel = this.excel.bind(this);
		this.getDate = this.getDate.bind(this);
		this.pmandcalibrationbyhospitaldetails = this.pmandcalibrationbyhospitaldetails.bind(this);
		this.renderChart = this.renderChart.bind(this);
		this.chartOnClick = this.chartOnClick.bind(this);
		this.getTabClass = this.getTabClass.bind(this);
		this.getTabPaneClass = this.getTabPaneClass.bind(this);
		this.setActiveTab = this.setActiveTab.bind(this);
		this.listbodyRef = this.listbodyRef.bind(this);
		this.renderTableHeaderRow = this.renderTableHeaderRow.bind(this);
		this.gotoLastTile = this.gotoLastTile.bind(this);
	}

	componentWillMount() {
		let reload =  this.props.location.params && this.props.location.params.reloadNextPage ? true : false;
		this.onload(reload);
		this.setActiveTab(1);
	}

	getDate(param){
		let tempObj = {
			fromdate : null,
			todate : null
		};
		if(this.props.app.companyid == 1 && ['Mumbai'].includes(this.props.app.branch)){
			tempObj.fromdate = moment().startOf('quarter').toString();
			tempObj.todate = moment().endOf('quarter').toString();
		}
		else if(this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch)){
			let quarterObj = {
				'15/Jan/2024 to 14/Jan/2025' : {
					'Q1': '15/Jan/2024 to 14/Apr/2024','Q2': '15/Apr/2024 to 14/Jul/2024','Q3': '15/Jul/2024 to 14/Oct/2024','Q4': '15/Oct/2024 to 14/Jan/2025'
				},
				'15/Jan/2025 to 14/Jan/2026' : {
					'Q1': '15/Jan/2025 to 14/Apr/2025','Q2': '15/Apr/2025 to 14/Jul/2025','Q3': '15/Jul/2025 to 14/Oct/2025','Q4': '15/Oct/2025 to 14/Jan/2026'
				}
			};
			Object.keys(quarterObj).map((item)=>{
				let yearStart = item.split(' to ')[0];
				let yearEnd = item.split(' to ')[1];

				if(new Date() >= new Date(yearStart) && new Date() <= new Date(yearEnd)){
					let quarter = Object.keys(quarterObj[item]).find((key)=>{
						let startDate = quarterObj[item][key].split(' to ')[0];
						let endDate = quarterObj[item][key].split(' to ')[1];
						if(new Date() >= new Date(startDate) && new Date() <= new Date(endDate)) return key;
					});
					tempObj.fromdate = moment(quarterObj[item][quarter].split(' to ')[0],'DD/MMM/YYYY').toString();
					tempObj.todate = moment(quarterObj[item][quarter].split(' to ')[1],'DD/MMM/YYYY').toString();
				}
			});
		}
		else if((this.props.app.companyid == 1 && !['Mumbai', 'Mumbai New'].includes(this.props.app.branch)) || this.props.app.companyid == 3 || this.props.app.companyid == 9 || this.props.app.companyid == 4){
			tempObj.fromdate = moment().startOf('month').toString();
			tempObj.todate = moment().endOf('month').toString();
		}else{
			tempObj.fromdate = moment().startOf('month').toString();
			tempObj.todate = moment().endOf('month').toString();
		}

		return tempObj[param];
	}

	gotoLastTile(){
		this.props.updateComponentState(this.props.form,{
			...this.state,wonumber:null,menumber:null,reloadNextPage:false
		});
		setTimeout(()=>{
			let tempObj ={
				fromdate : this.state.fromdate,
				todate : this.state.todate,
				pmtype : this.state.pmtype,
				menumber : this.state.menumber,
				wonumber : this.state.wonumber
			};
			return this.props.history.push({pathname: `/pmandcalibrationbyhospitaldetails/null`, params: tempObj});
		}, 0);
	}

	onload(reload){
		if(this.state.menumber || this.state.wonumber) return this.gotoLastTile();

		if(!reload && this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			this.setState({loaderflag:true});
			let filterstring = '';
			if(this.state.fromdate && this.state.todate){
				filterstring=`&fromdate=${new Date(this.state.fromdate).toDateString()}&todate=${new Date(this.state.todate).toDateString()}`
			}
			if(this.state.pmtype)
				filterstring += `&pmtype=${this.state.pmtype}`;

			// if(this.state.menumber)
			// 	filterstring += `&menumber=${this.state.menumber}`;

			// if(this.state.wonumber)
			// 	filterstring += `&wonumber=${this.state.wonumber}`;
			
			axios.get(`/api/pmandcalibration?pagetype=hospital&groupid=${this.props.match.params.groupid}&territoryid=${this.props.match.params.territoryid}${filterstring}`).then((response) => {
				if (response.data.message == 'success') {
					
					let result=[],t_sp_scheduled=0,t_sp_completed=0,t_sp_pending=0,t_w_scheduled=0,t_w_completed=0,t_w_pending=0,t_nsp_scheduled=0,t_nsp_completed=0,t_nsp_pending=0;

					if(response.data.main && response.data.main.length > 0){
						response.data.main.forEach((item)=>{
							t_sp_scheduled += item.sp_scheduled;
							t_sp_completed += item.sp_completed;
							t_sp_pending += item.sp_pending;
							t_w_scheduled += item.w_scheduled;
							t_w_completed += item.w_completed;
							t_w_pending += item.w_pending;
							t_nsp_scheduled += item.nsp_scheduled;
							t_nsp_completed += item.nsp_completed;
							t_nsp_pending += item.nsp_pending;
						});
						result = response.data.main;
					}
					
					this.setState({
						result ,t_sp_scheduled,t_sp_completed,t_sp_pending,t_w_scheduled,t_w_completed,t_w_pending,t_nsp_scheduled,t_nsp_completed,t_nsp_pending,loaderflag : false,reloadNextPage:true
					});
					this.props.updateComponentState(this.props.form,{
						result ,t_sp_scheduled,t_sp_completed,t_sp_pending,t_w_scheduled,t_w_completed,t_w_pending,t_nsp_scheduled,t_nsp_completed,t_nsp_pending,loaderflag : false,fromdate:this.state.fromdate,todate:this.state.todate,pmtype:this.state.pmtype,wonumber:this.state.wonumber,menumber:this.state.menumber
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	pmandcalibrationbyhospitaldetails(item){
		let tempObj ={
			partnerid : item.id,
			fromdate:this.state.fromdate,
			todate:this.state.todate,
			pmtype : this.state.pmtype,
			//menumber : this.state.menumber,
			//wonumber : this.state.wonumber,
			reloadNextPage : this.state.reloadNextPage
		};
		this.props.history.push({pathname: `/pmandcalibrationbyhospitaldetails/${item.id}`, params: tempObj});
	}

	excel(status,contractstatus,partnerid,header){
		
		this.setState({loaderflag:true});

		let filterstring = [];

		if(status)
			filterstring.push(`status=${status}`);

		if(contractstatus)
			filterstring.push(`contractstatus=${contractstatus}`);

		if(partnerid)
			filterstring.push(`partnerid=${partnerid}`);

		if(this.props.match.params.groupid > 0)
			filterstring.push(`partnergroupid=${this.props.match.params.groupid}`);

		if(this.props.match.params.territoryid > 0)
			filterstring.push(`territoryid=${this.props.match.params.territoryid}`);

		if(this.state.pmtype)
			filterstring.push(`pmtype=${this.state.pmtype}`);

		// if(this.state.wonumber)
		// 	filterstring.push(`wonumber=${this.state.wonumber}`);

		// if(this.state.menumber)
		// 	filterstring.push(`menumber=${this.state.menumber}`);

		if(this.state.fromdate && this.state.todate){
			filterstring.push(`fromdate=${new Date(this.state.fromdate).toDateString()}`);
			filterstring.push(`todate=${new Date(this.state.todate).toDateString()}`);
		}
		
		let coldefArray = [{
			"name" : `${this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New'].includes(this.props.app.branch) ? 'State' : 'District'}`,
			"key" : "state",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "WO Number",
			"key" : "servicecallno",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "Wo Date",
			"key" : "servicecalldate",
			"cellClass" : "text-center",
			"format" : "date",
			"width" : 150
		},{
			"name" : `${this.props.app.companyid == 8 ? 'Department' : 'Hospital'}`,
			"key" : "hospital",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "ME Number",
			"key" : "menumber",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "Equipment Name",
			"key" : "mename",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "Department",
			"key" : "department",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "Work Done Date",
			"key" : "completeddate",
			"cellClass" : "text-center",
			"format" : "date",
			"width" : 150
		},{
			"name" : "Functional Status",
			"key" : "functionalstatus",
			"cellClass" : "text-center",
			"width" : 200
		},{
			"name" : "Comments",
			"key" : "actiontaken",
			"cellClass" : "text-center",
			"width" : 200
		},{
			"name" : "Work Status",
			"key" : "workstatus",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "PM Status",
			"key" : "pmtype",
			"cellClass" : "text-center",
			"width" : 150
		},{
			"name" : "Next PM Due Date",
			"key" : "nextscheduledate",
			"cellClass" : "text-center",
			"format" : "date",
			"width" : 150
		}];
		
		axios.get(`/api/pmandcalibrationexcel?${filterstring.join('&')}`).then((response) => {
			if (response.data.message == 'success') {
				generateExcel('Preventive Maintenance By Hospital', coldefArray,response.data.main, () => {
					this.setState({loaderflag:false});
				});
			} else {
				this.setState({loaderflag:false});
			}
		});
	}

	chartOnClick(element,event){
		console.log("onclick-element........",element);
		console.log("onclick-event........",event);
	}

	getTabClass(tabNum) {
		return this.state.tabClasses[tabNum];
	}

	getTabPaneClass(tabNum) {
		return this.state.tabClasses[tabNum];
	}

	setActiveTab(tabNum) {
		let { tabClasses } = this.state;
		tabClasses =  ["", ""]
		tabClasses[tabNum] = "show active";
		this.setState({tabClasses});
		setTimeout(()=>{
			this.updateWindowSize();
		}, 0);
	}

	renderChart(){
		let chartData = {
			labels : [],
			datasets : []
		}; 
		let fsObj = {
			'Scheduled' : [],
			'Completed' : [],
			'Pending' : [],
		};

		let resultArray = this.state.result;

		resultArray.forEach((item)=>{
			chartData.labels.push(item.hospital);
			fsObj['Scheduled'].push(item.sp_scheduled);
			fsObj['Completed'].push(item.sp_completed);
			fsObj['Pending'].push(item.sp_pending);
		});

		Object.keys(fsObj).forEach((item,index)=>{
			chartData.datasets.push({
				label : item,
				data : fsObj[item],
				stack : index.toString(),
				backgroundColor : colors[index],
			});
		});

		let length = chartData.labels ? chartData.labels.length : 0;
		let width = 0;
        if(length <= 50) {
        	width = 2000;
        }else if(length >= 51 && length <= 100){
        	width = 3000
        }else{
        	width = 4000
        }
		
		return (
			<div className="fulldiv">
				<Bar data={chartData} options={options} width={width} height={500} getElementAtEvent={this.chartOnClick} />
			</div>
        );
	}

	renderTableHeaderRow() {
		let { t_sp_scheduled,t_sp_completed,t_sp_pending,t_w_scheduled,t_w_completed,t_w_pending,t_nsp_scheduled,t_nsp_completed,t_nsp_pending } = this.state;

		return (
			<thead>
				<tr>
					<th ></th>
					<th colSpan="3" className="text-center table-header">Under Service Provider</th>
					<th colSpan="3" className="text-center table-header">Under Warranty/AMC</th>
					<th colSpan="3" className="text-center table-header">Out of Warranty/AMC</th>
				</tr>
				<tr>
					<th className="text-center table-header">{this.props.app.companyid == 8 ? 'Department' : 'Hospital'}</th>
					<th className="text-center table-header">Scheduled <br/><a href="javascript:void(0)" onClick={()=>{this.excel('','Service Provider',null,true)}}>{t_sp_scheduled}</a></th>
					<th className="text-center table-header">Completed <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Completed','Service Provider',null,true)}}>{t_sp_completed}</a></th>
					<th className="text-center table-header">Pending <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Pending','Service Provider',null,true)}}>{t_sp_pending}</a></th>
					<th className="text-center table-header">Scheduled <br/><a href="javascript:void(0)" onClick={()=>{this.excel('','Warranty / AMC',null,true)}}>{t_w_scheduled}</a></th>
					<th className="text-center table-header">Completed <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Completed','Warranty / AMC',null,true)}}>{t_w_completed}</a></th>
					<th className="text-center table-header">Pending <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Pending','Warranty / AMC',null,true)}}>{t_w_pending}</a></th>
					<th className="text-center table-header">Scheduled <br/><a href="javascript:void(0)" onClick={()=>{this.excel('','Out of Warranty/AMC',null,true)}}>{t_nsp_scheduled}</a></th>
					<th className="text-center table-header">Completed <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Completed','Out of Warranty/AMC',null,true)}}>{t_nsp_completed}</a></th>
					<th className="text-center table-header">Pending <br/><a href="javascript:void(0)" onClick={()=>{this.excel('Pending','Out of Warranty/AMC',null,true)}}>{t_nsp_pending}</a></th>
				</tr>
			</thead>
		);
	}

	listbodyRef(node) {
		if(node) {
			node.addEventListener('scroll', (evt) => {
				this.refs.listheader.scrollLeft = evt.srcElement.scrollLeft;
			});
		}
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_width = document.getElementsByClassName('trimed-table_body') ? document.getElementsByClassName('trimed-table_body')[0].clientWidth : 0;
			this.setState({ table_header_width });
		}, 300);
		window.addEventListener('resize', this.updateWindowSize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowSize);
	}

	updateWindowSize = () => {
		this.setState((prevState) => {
			return {
				duplicatereload: !prevState.duplicatereload
			}
		});
	}

	render() {

		let { result,t_sp_scheduled,t_sp_completed,t_sp_pending,t_w_scheduled,t_w_completed,t_w_pending,t_nsp_scheduled,t_nsp_completed,t_nsp_pending,loaderflag } = this.state;

		let table_body_height = $(window).outerHeight() - $('.header').outerHeight() -$('.page_title').outerHeight() - $('.page_filter').outerHeight() - $('.gs-custom-tab').outerHeight() - 60;

		let isTableHasScrollbar = $('.trimed_table_container').outerHeight() < $('.trimed-table_body').outerHeight() ? true : false;

		let tablebody_scrollWidth = $('.table_body_wrapper').outerWidth() - $('.trimed-table_body').outerWidth();

		return (
			<div className="row">
				<div className="col-lg-12 col-md-12">
					<Loadingcontainer isloading={loaderflag}></Loadingcontainer>
					<div className="row page_title">
						<div className="col-lg-12 col-md-12" >
							<div className="d-flex flex-row justify-content-between margintop-10 marginbottom-10 card-details-header">
								<div>
									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left"}} onClick={()=>{this.props.history.push('/');}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#0EC98D",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/home-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#11E4A1",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Home
										</div>
									</div>

									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left",marginLeft:"5px"}} onClick={()=>{this.props.history.goBack();}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#6881FF",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/back-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#8599FF",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Back
										</div>
									</div>
								</div>
								<div className=" drilldown-header" style={{textAlign:"center",float:"left",fontFamily: "Poppins",fontStyle: "normal",fontSize:"20px"}}>
										Preventive Maintenance
								</div>
								<div></div>
							</div>
						</div>
					</div>
					<div className="row page_filter">
						{
							(!this.props.app.isDemoDashboard) ?
								<div className="form-group col-lg-2 col-md-3">
									<DateElement className="form-control" placeholder="Select From Date" value={this.state.fromdate} onChange={(value)=>{this.setState({fromdate:value});}}/>
								</div>
							: null
						}
						{
							(!this.props.app.isDemoDashboard) ?
								<div className="form-group col-lg-2 col-md-3">
									<DateElement className="form-control" placeholder="Select To Date" value={this.state.todate} onChange={(value)=>{this.setState({todate:value});}}/>
								</div>
							: null
						}
						<div className="form-group col-lg-2 col-md-3">
							<LocalSelect placeholder={'Select Type'} name={'pmtype'} options={['PM','Calibration']} value={this.state.pmtype} multiselect={false} required={false} onChange={(value)=>{this.setState({pmtype:value})}}/>
						</div>
						<div className="form-group col-lg-2 col-md-3">
							<input key={'menumber'} type="text" className={`form-control`}  value={this.state.menumber} placeholder={'ME Number'} onChange={(event)=>{this.setState({menumber:event.target.value})}} required={false} autoComplete="off" ></input>
						</div>
						<div className="form-group col-lg-2 col-md-3">
							<input key={'wonumber'} type="text" className={`form-control`}  value={this.state.wonumber} placeholder={'WO Number'} onChange={(event)=>{this.setState({wonumber:event.target.value})}} required={false} autoComplete="off" ></input>
						</div>
						<div className="form-group col-lg-1 col-md-2">
							<button type="button" className="btn btn-sm btn-primary" onClick={()=>{this.onload(true);}}>Go</button>
						</div>
					</div>
					<div className="row no-gutters">
					{
						(result && result.length > 0) ? 
							<div className="col-md-12" style={{backgroundColor: '#fff'}}>
								<ul className="nav nav-tabs gs-custom-tab">
									<li style={{width:'25px'}}></li>
									<li className="nav-item">
										<a className={`nav-link ${this.getTabClass(1)}`} href="javascript:void(0);" onClick={()=>this.setActiveTab(1)}>Data</a>
									</li>
									<li className="nav-item">
										<a className={`nav-link ${this.getTabClass(2)}`} href="javascript:void(0);" onClick={()=>this.setActiveTab(2)} >Chart</a>
									</li>
								</ul>
								<div className="tab-content">
									<div className={`tab-pane fade ${this.getTabPaneClass(1)}`} role="tabpanel">
										<div className="row no-gutters" style={{padding: '20px'}}>
											<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 trimed_table_container">
												<div className="equip_profile_table_header trimed-table-wrapper" ref="listheader" style={{width: `${isTableHasScrollbar && tablebody_scrollWidth > 1 ? `calc(100% - ${tablebody_scrollWidth}px)` : '100%'}`}}>
													<table className="table table-bordered trimed-table">
														<colgroup>
															<col className="bg_gray" style={{width: '210px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
														</colgroup>
														{this.renderTableHeaderRow()}
													</table>
												</div>
												<div className="table_body_wrapper" ref={this.listbodyRef} style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}>
													<table className="table table-hover table-bordered trimed-table trimed-table_body">
														<colgroup>
															<col className="bg_gray" style={{width: '210px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_green" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_blue" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
															<col className="bg_orange" style={{width: '84px'}} />
														</colgroup>
														{this.renderTableHeaderRow()}
														<tbody>
															{result.map((item, key) => {
																return <tr key={key}>
																	<td className="text-center table-content" onClick={()=>{this.pmandcalibrationbyhospitaldetails(item)}} style={{wordBreak: 'break-all'}}>{item.hospital}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('','Service Provider',item.id)}}>{item.sp_scheduled}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Completed','Service Provider',item.id)}} >{item.sp_completed}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Pending','Service Provider',item.id)}} >{item.sp_pending}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('','Warranty / AMC',item.id)}} >{item.w_scheduled}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Completed','Warranty / AMC',item.id)}} >{item.w_completed}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Pending','Warranty / AMC',item.id)}} >{item.w_pending}</td>

																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('','Out of Warranty/AMC',item.groupid)}} >{item.nsp_scheduled}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Completed','Out of Warranty/AMC',item.groupid)}} >{item.nsp_completed}</td>
																	<td className="text-center table-body-count cursor-ptr" onClick={()=>{this.excel('Pending','Out of Warranty/AMC',item.groupid)}} >{item.nsp_pending}</td>
																</tr>
															})}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div className={`tab-pane fade ${this.getTabPaneClass(2)}`} role="tabpanel">
										<div className="row no-gutters" style={{padding: '20px'}}>
											<div className="col-md-12 col-sm-12 col-xs-12">
												{(result.length > 0) ? this.renderChart(): null}
											</div>
										</div>
									</div>
								</div>
							</div>
						: <div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}><div style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}><Drilldownplaceholder reportdata={result}></Drilldownplaceholder></div></div>
					}
					</div>
				</div>
			</div>
		);
	}
}

PMAndCalibrationByHospital = connect(
	(state, props) => {
		let formName = `pmandcalibrationbyhospital${props.match.params.groupid > 0 ? '_'+props.match.params.groupid : ''}${props.match.params.territoryid > 0 ? '_'+props.match.params.territoryid:''}`;

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState, updateComponentState }
)(reduxForm()(PMAndCalibrationByHospital));

export default PMAndCalibrationByHospital;


// WEBPACK FOOTER //
// ./public/react/components/drilldowns/pmandcalibrationbyhospital.js